module.exports = __webpack_public_path__ + "img/affe43c.png";